import { useCallback, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import UIClickable from 'UIComponents/button/UIClickable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { CALYPSO, GREAT_WHITE, KOALA } from 'HubStyleTokens/colors';
import { getCategoryI18nKey, getSuperCategoryI18nKey
// @ts-expect-error untyped import
} from 'ecosystem-marketplace-core/utils/i18n';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
// @ts-expect-error untyped import
import MobileNavigationPanel from './MobileNavigationPanel';
// @ts-expect-error untyped import

import * as FilterKey from '../../../../constants/search/FilterKey';
import { useAppContext } from '../../../../context/AppContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullWidthContainer = styled.div.withConfig({
  displayName: "MobileNavigator__FullWidthContainer",
  componentId: "sc-16muqx0-0"
})(["&&{background-color:", ";border-bottom:1px solid ", ";left:50%;right:50%;margin-left:-50vw;margin-right:-50vw;position:relative;width:100vw;}"], KOALA, GREAT_WHITE);
const FullSizeClickable = styled(UIClickable).withConfig({
  displayName: "MobileNavigator__FullSizeClickable",
  componentId: "sc-16muqx0-1"
})(["&&{background-color:", ";height:100%;width:100%;padding:12px;padding-right:28px;padding-left:28px;}"], KOALA);
const MobileNavigator = ({
  className,
  filters,
  isAllCategories,
  onCategoryChange,
  trackFilterNavItemClick,
  url
}) => {
  const [panelOpen, setPanelOpen] = useState(false);
  const appContext = useAppContext();
  const {
    data: collections
  } = useCollections({
    appContext,
    offeringType: 'APP'
  });
  const mobileNavRef = useRef(null);
  const titleText = useMemo(() => {
    if (filters.get(FilterKey.CATEGORY)) {
      return unescapedText(getCategoryI18nKey(filters.get(FilterKey.CATEGORY)));
    }
    if (filters.get(FilterKey.SUPER_CATEGORY)) {
      return unescapedText(getSuperCategoryI18nKey(filters.get(FilterKey.SUPER_CATEGORY)));
    }
    if (isAllCategories) {
      return unescapedText('appMarketplace.storefront.filters.category.items.all.titleText');
    }
    const matchingCollection = collections.find(collection => collection.publishedListing && url === `/${collection.publishedListing.slug}`);
    return matchingCollection && matchingCollection.publishedListing ? matchingCollection.publishedListing.name : '';
  }, [collections, filters, isAllCategories, url]);
  const onOpenPanel = useCallback(() => {
    setPanelOpen(true);
  }, [setPanelOpen]);
  const onClosePanel = useCallback(() => {
    if (mobileNavRef.current !== null) mobileNavRef.current.focus();
    setPanelOpen(false);
  }, [setPanelOpen]);
  const renderedPanel = useMemo(() => {
    return /*#__PURE__*/_jsx(MobileNavigationPanel, {
      filters: filters,
      onCategoryChange: onCategoryChange,
      onPanelClose: onClosePanel,
      open: panelOpen,
      trackFilterNavItemClick: trackFilterNavItemClick
    }, filters);
  }, [filters, onCategoryChange, onClosePanel, panelOpen, trackFilterNavItemClick]);
  return /*#__PURE__*/_jsxs(FullWidthContainer, {
    className: className,
    children: [/*#__PURE__*/_jsx(FullSizeClickable, {
      buttonRef: mobileNavRef,
      onClick: onOpenPanel,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "between",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: 'appMarketplace.storefront.mobileNavigation.mobileNavigatorText',
          options: {
            title: titleText
          }
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "right",
          color: CALYPSO,
          size: "xs"
        })]
      })
    }), renderedPanel]
  });
};
export default MobileNavigator;